import { render, staticRenderFns } from "./personPrestoreRecord.vue?vue&type=template&id=71da23f6"
import script from "./personPrestoreRecord.vue?vue&type=script&lang=js"
export * from "./personPrestoreRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports